import axios from 'axios';
import { useState } from 'react';

export const useSendFeedback = () => {
  const [loadingSendFeedback, setLoadingSendFeedback] = useState(false);

  const updateRequestedFeedback = async (data) => {
    setLoadingSendFeedback(true);
    try {
      await axios.patch('api/feedback', data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSendFeedback(false);
    }
  };
  const sendFeedback = async (data) => {
    setLoadingSendFeedback(true);
    try {
      await axios.post('api/feedback', data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSendFeedback(false);
    }
  };

  return { loadingSendFeedback, sendFeedback, updateRequestedFeedback };
};
